<template>
    <v-flex xs12 sm12 d-block class="card-dados card-dados__mobile">
        <h3 id="tituloPainel" class="card-dados__titulo mb-0">Listagem</h3>

        <div v-if="value.length > 1" class="text-xs-right acao-expandir-recolher">
            <v-btn v-if="ultimoEstadoPaineis === 'recolhido'" flat @click="expandirTodos" class="botao-simples mr-3">
                <v-icon left size="15">fas fa-chevron-down</v-icon>
                Expandir Todos
            </v-btn>
            <v-btn v-else flat @click="recolherTodos" class="botao-simples mr-3">
                <v-icon left size="15">fas fa-chevron-up</v-icon>
                Recolher Todos
            </v-btn>
        </div>

        <v-expansion-panel v-model="paineis" expand class="painel-itens" :class="{ 'mt-3': value.length < 2}">
            <v-expansion-panel-content v-for="lote in value" :key="lote.id" class="painel-itens__linha cabecalho-painel">
                <template v-slot:header>
                    <p>
                        <strong>{{ lote.descricao }}</strong> -
                        <v-tooltip top v-if="lote.motivo">
                            <a slot="activator">
                                {{ lote.situacao | azEnum(situacoesItensELotes) }}
                                <i class="fas fa-comment" aria-hidden="true"/>
                            </a>
                            {{ lote.motivo }}
                        </v-tooltip>
                        <span v-else>
                            {{ lote.situacao | azEnum(situacoesItensELotes) }}
                        </span>
                    </p>
                    <div class="painel-itens__info">
                        <p>Exclusivo {{formatarLista(portes) | azConcat}}:</p>
                        <p class="ml-2">{{ lote.porteExclusivo ? 'Sim' : 'Não' }}</p>
                    </div>
                </template>

                <painel-lote-tabela
                    :itens="lote.itens"
                    :possuiValorReferencia="possuiValorReferencia"
                    :prefixOuSuffixValor="prefixOuSuffixValorCurrency"
                    :criterioJulgamento="criterioJulgamentoDaCompra"
                    :isCriterioJulgamentoMaiorDesconto="isCriterioJulgamentoMaiorDesconto"
                    :casasDecimais="casasDecimais"
                    :casasDecimaisQuantidade="casasDecimaisQuantidade"/>

                <div class="total total-mobile" v-if="possuiValorReferencia && isCriterioJulgamentoMaiorDesconto">
                    <p>
                      <strong>Desconto:</strong> {{ lote.totalGeral | cdCurrency(prefix, casasDecimais) }}{{suffix}}
                    </p>
                </div>
                <div class="total total-mobile" v-if="possuiValorReferencia && !isCriterioJulgamentoMaiorDesconto">
                      <p>
                          <strong>Total Unitário:</strong> {{ lote.totalUnitario | cdCurrency(prefix, casasDecimais) }}{{suffix}} |
                          <strong>Total Geral:</strong> {{ lote.totalGeral | cdCurrency(prefix, casasDecimais) }}{{suffix}}
                      </p>
                </div>
            </v-expansion-panel-content>
        </v-expansion-panel>

        <div class="total total-listagem" v-if="possuiValorReferencia && !isCriterioJulgamentoMaiorDesconto && value.length > 1">
            <p>
                <strong>Total: </strong> {{ total | cdCurrency(prefix, casasDecimais) }}{{suffix}}
            </p>
        </div>
    </v-flex>
</template>

<script>
import PainelLoteTabela from './PainelLoteTabela'
import {situacoesItensELotes} from '@/core/constants'

export default {
    name: 'PainelLoteVisualizacao',
    components: {
        PainelLoteTabela
    },
    props: {
        value: {
            required: true,
            type: Array,
            default: () => {
                return []
            }
        },
        casasDecimais: {
            type: Number,
            default: 2
        },
        prefixOuSuffixValor:{
            type: String
        },
        criterioJulgamento: {
            type: String
        },
        isCriterioJulgamentoMaiorDesconto:{
            type: Boolean,
            default: false
        },
        possuiValorReferencia:{
            type: Boolean
        },
        casasDecimaisQuantidade: {
            type: Number,
            default: 2
        }
    },
    data() {
        return {
            paineis: [],
            totalmenteExpandido: false,
            totalmenteRecolhido: true,
            ultimoEstadoPaineis: 'recolhido',
            situacoesItensELotes
        }
    },
    computed: {
        total() {
            let total = 0
            this.value.forEach(lote => {
                if (lote.totalGeral > 0) {
                    total += lote.totalGeral
                }
            })
            return total
        },
        prefix(){
            return this.prefixOuSuffixValor === 'R$' ? 'R$ ' : ''
        },
        suffix(){
            return this.prefixOuSuffixValor === '%' ? '%' : ''
        },
        criterioJulgamentoDaCompra(){
            return this.criterioJulgamento
        },
        prefixOuSuffixValorCurrency(){
            return this.prefixOuSuffixValor
        }
    },
    mounted() {
        this.expandirTodos()
    },
    methods: {
        recolherTodos() {
            const todosPaineisFechados = this.value.map(() => {
                return false
            })
            this.paineis = todosPaineisFechados
            this.totalmenteExpandido = false
        },
        expandirTodos() {
            const todosPaineisAbertos = this.value.map(() => {
                return true
            })
            this.paineis = todosPaineisAbertos
            this.totalmenteExpandido = true
            this.verificarUltimoEstado()
        },
        verificarUltimoEstado() {
            if (this.totalmenteExpandido) {
                this.ultimoEstadoPaineis = 'expandido'
            } else if (this.totalmenteRecolhido) {
                this.ultimoEstadoPaineis = 'recolhido'
            }
        }
    },
    watch: {
        paineis() {
            let todosExpandidos = true
            let todosRecolhidos = true

            for (let posicao of this.paineis) {
                if (!posicao) {
                    todosExpandidos = false
                } else {
                    todosRecolhidos = false
                }
            }

            this.totalmenteExpandido = todosExpandidos
            this.totalmenteRecolhido = todosRecolhidos
            this.verificarUltimoEstado()
        }
    }
}
</script>

<style scoped lang="stylus">
    .painel-itens__info
        margin-right 20px

    @media (max-width 720px)
        .painel-itens__info
            margin-right 10px
</style>
